const indexItems = [
  {
    title: '2026暑期档必看清单',
    desc: '收录今夏最受期待的院线大片与流媒体新片',
    count: '32部',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20collage%20with%20warm%20sunset%20glow%2C%20vintage%20movie%20posters%20arranged%20artistically%2C%20palm%20trees%20silhouette%2C%20golden%20hour%20lighting%2C%20nostalgic%20film%20aesthetic&width=500&height=340&seq=index-summer&orientation=landscape',
  },
  {
    title: '豆瓣8.5+高分电影',
    desc: '口碑炸裂的高分佳作，每一部都值得反复观看',
    count: '58部',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20with%20film%20award%20trophies%20on%20dark%20velvet%2C%20warm%20spotlight%20illuminating%2C%20golden%20accents%2C%20prestige%20cinema%20aesthetic%2C%20rich%20textures&width=500&height=340&seq=index-highscore&orientation=landscape',
  },
  {
    title: '韩剧热播追更日历',
    desc: '最新韩剧更新时间和追剧指南，不再错过更新',
    count: '24部',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20scene%20with%20soft%20natural%20lighting%2C%20cherry%20blossom%20and%20urban%20Seoul%20backdrop%2C%20warm%20pink%20and%20cream%20tones%2C%20romantic%20cinematic%20atmosphere&width=500&height=340&seq=index-kdrama&orientation=landscape',
  },
  {
    title: '漫威DC超英合集',
    desc: '按时间线整理的超英电影观看顺序，入坑指南',
    count: '47部',
    img: 'https://readdy.ai/api/search-image?query=Epic%20superhero%20cinematic%20scene%20with%20dramatic%20skyline%20at%20twilight%2C%20comic%20book%20aesthetic%2C%20bold%20silhouettes%2C%20vibrant%20color%20grading%2C%20heroic%20composition&width=500&height=340&seq=index-superhero&orientation=landscape',
  },
  {
    title: '宫崎骏动画全收录',
    desc: '从风之谷到你想活出怎样的人生，完整作品集',
    count: '24部',
    img: 'https://readdy.ai/api/search-image?query=Whimsical%20Studio%20Ghibli%20inspired%20landscape%20with%20rolling%20green%20hills%2C%20fluffy%20clouds%2C%20warm%20sunlight%2C%20hand-drawn%20animation%20aesthetic%2C%20dreamy%20pastel%20color%20palette&width=500&height=340&seq=index-ghibli&orientation=landscape',
  },
  {
    title: '国产犯罪片精选',
    desc: '从烈日灼心到三大队，国产犯罪题材巅峰之作',
    count: '36部',
    img: 'https://readdy.ai/api/search-image?query=Moody%20urban%20night%20scene%20with%20rain-slicked%20streets%2C%20neon%20sign%20reflections%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20warm%20street%20light%2C%20cinematic%20atmosphere&width=500&height=340&seq=index-crime&orientation=landscape',
  },
  {
    title: 'BBC自然纪录片',
    desc: '地球脉动、蓝色星球等高分自然纪录片大全',
    count: '29部',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20nature%20landscape%20with%20dramatic%20mountains%20and%20golden%20light%2C%20National%20Geographic%20documentary%20aesthetic%2C%20rich%20earthy%20tones%2C%20lens%20flare%20through%20clouds&width=500&height=340&seq=index-nature&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              专题合集
            </h2>
            <p className="text-foreground-500 text-sm">按类型、主题整理的影视合集，找片更轻松</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {indexItems.map((item, i) => (
              <div
                key={i}
                className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 right-3">
                    <span className="inline-block px-2.5 py-1 bg-background-50/90 text-foreground-800 text-xs font-semibold rounded-md">
                      {item.count}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1.5 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}